/* eslint-disable @next/next/no-img-element */
/* eslint-disable no-nested-ternary */
import {
  AuthFill,
  Button,
  CompanyName,
  Email,
  FirstName,
  LastName,
  MarketingConsentSimple,
  Title,
} from '@components/form/fields'
import { FormStep, FormWrapper } from '@components/form/layout'
import { Nav } from '@components/ui'
import { yupResolver } from '@hookform/resolvers/yup'
import { ERROR_MESSAGE } from '@utils/constants'
import { closeOverlay, getPageData } from '@utils/helpers'
import { formEvent } from '@utils/helpers/tracking'
import { FleetNewsletterSchema } from '@utils/schemas'
import axios from 'axios'
import type { GetServerSideProps } from 'next'
import { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

const FleetNewsletter = ({ content, tracking, brand }) => {
  const [submitResponse, setSubmitResponse] = useState('')
  const initialValues = {
    title: '',
    first_name: '',
    last_name: '',
    email: '',
    company_name: '',
    consent: false,
    is_lexus: brand === 'lexus',
  }

  const methods = useForm({
    resolver: yupResolver(FleetNewsletterSchema),
    defaultValues: initialValues,
    mode: 'onTouched',
  })

  const onSubmit = async (data) => {
    setSubmitResponse('')
    await axios({
      method: 'post',
      url: `${process.env.NEXT_PUBLIC_API}/fleet-newsletter`,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    })
      .then(() => {
        formEvent({
          conversion: 1,
          name: tracking.form,
          step: 'form-submit',
          variant: '',
          page: tracking.page,
        })
        closeOverlay(
          content.confirmation.title,
          content.confirmation.copy,
          setSubmitResponse,
          brand === 'lexus',
        )
      })
      .catch(() => {
        formEvent({
          conversion: 0,
          name: tracking.form,
          step: 'form-error',
          variant: '',
          page: tracking.page,
        })
        setSubmitResponse(ERROR_MESSAGE)
        throw new Error(ERROR_MESSAGE)
      })
  }

  return (
    <>
      <Nav
        title={content.title}
        background={content.background}
        color={content.colour}
      />
      <FormWrapper>
        <FormStep
          title={content.details.title}
          subtitle={content.details.subtitle}
          active={true}
        >
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <AuthFill />
              <Title />
              <FirstName />
              <LastName />
              <CompanyName />
              <Email />
              <MarketingConsentSimple />
              <Button submitResponse={submitResponse}>
                {content.details.submit}
              </Button>
            </form>
          </FormProvider>
        </FormStep>
      </FormWrapper>
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const brand = context.locale
  const form = 'newsletter-fleet'
  const content = await import(`../../content/${brand}/forms/${form}.md`).catch(
    () => null,
  )

  // if no content/disabled - show 404
  if (!content || !content.attributes?.active) {
    return {
      notFound: true,
    }
  }

  // if content property 'hold' is true, redirect to holding page
  if (content.attributes?.hold) {
    return {
      redirect: {
        destination: '/maintenance',
        permanent: false,
      },
    }
  }

  return {
    props: {
      content: content.attributes,
      title: content.attributes.title,
      tracking: {
        page: 'fleet-newsletter',
        form: 'lead-fleet-newsletter',
        variant: '',
        initialStep: 'contact-details',
      },
      description: '',
      ...(await getPageData(context)),
    },
  }
}

FleetNewsletter.whyDidYouRender = true

export default FleetNewsletter
